import { render, staticRenderFns } from "./messageListRight.vue?vue&type=template&id=3c55fe66&scoped=true"
import script from "./messageListRight.vue?vue&type=script&lang=js"
export * from "./messageListRight.vue?vue&type=script&lang=js"
import style0 from "./messageListRight.vue?vue&type=style&index=0&id=3c55fe66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55fe66",
  null
  
)

export default component.exports